import React, { ReactNode } from "react";
import { Box } from "@mui/material";
import {
  SectionContainer,
  SectionHeader,
  SectionTitle,
  SectionContent,
} from "./PageSection.styled";

interface PageSectionProps {
  title: string | ReactNode;
  content?: string | ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
  maxContentHeight?: string | number;
  allowHtml?: boolean;
}

/**
 * Reusable section component with title, content/children, and optional actions
 */
const PageSection: React.FC<PageSectionProps> = ({
  title,
  content,
  actions,
  children,
  maxContentHeight,
  allowHtml = false,
}) => {
  const contentStyle = maxContentHeight
    ? {
        maxHeight: maxContentHeight,
        overflow: "hidden",
      }
    : undefined;

  return (
    <SectionContainer>
      <SectionHeader>
        <SectionTitle>{title}</SectionTitle>
        {actions}
      </SectionHeader>
      {content && typeof content === "string" ? (
        allowHtml ? (
          <SectionContent
            sx={contentStyle}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        ) : (
          <SectionContent sx={contentStyle}>{content}</SectionContent>
        )
      ) : content ? (
        <Box sx={{ ...contentStyle }}>{content}</Box>
      ) : null}
      {children}
    </SectionContainer>
  );
};

export default PageSection;
